webpackJsonp([42],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_libs_common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_topbar_menu__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_utils__ = __webpack_require__(2);
/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */






function bindEvent() {
  // banner下立即申请
  $('.banner-to-service-manage').click(function () {
    var serviceKey = this.dataset.serviceKey;
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["g" /* toUrl */])(__WEBPACK_IMPORTED_MODULE_3_config__["a" /* config */].CONSOLE + 'services/' + serviceKey, '_blank');
  });
  $('.banner-apply-btn').click(function () {
    var $this = $(this);
    var href = Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["a" /* addCurrentPageParams */])($this.data('href'));
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["g" /* toUrl */])(href, '_blank');
  });
}

function init() {
  Object(__WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__["a" /* suspension */])();
  bindEvent();
}
init();

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return player; });
var player = function (my) {
  // 当前待播放音频地址
  var curUrl;
  // 上一个待播放音频地址
  var lastUrl;
  var $jplayer;
  // var Bubble
  // 回调函数
  var callback;

  var stopEvent = null;
  var playEvent = null;
  var playingEvent = null;
  var playErrorEvent = null;
  // 记录player监测flash未安装时是否发起请求swf文件
  var isReqSwf = false;
  // stoped后禁止调用canplay
  var canplayStatus = false;

  my.getStatus = function () {
    return $jplayer.attr('status');
  };

  my.buttonClick = function (url, cb, cbPlaying, cbStop, cbError, cbPlay) {
    // 保存回调
    callback = cb;
    // 重置回调
    stopEvent = cbStop;
    playEvent = cbPlay;
    playingEvent = cbPlaying;
    playErrorEvent = cbError;
    var urlParam = {};
    if (typeof url === 'string') {
      urlParam = {
        mp3: url
      };
    } else {
      urlParam = url;
    }

    // 保存上个元素的信息
    lastUrl = curUrl;
    curUrl = JSON.stringify(urlParam);

    if (lastUrl === curUrl) {
      my.play(false);
      return;
    }
    my.play(true);
  };
  // 播放：isNew==true，代表重新加载音频
  my.play = function (isNew) {
    if (isNew) {
      $jplayer.jPlayer('setMedia', JSON.parse(curUrl || '{}')).jPlayer('play');
    } else {
      $jplayer.jPlayer('play');
    }
  };
  my.playUrl = function (url) {
    curUrl = '';
    stopEvent = null;
    playEvent = null;
    playingEvent = null;
    playErrorEvent = null;
    var urlParam = {};
    if (typeof url === 'string') {
      urlParam = {
        mp3: url
      };
    } else {
      urlParam = url;
    }

    $jplayer.jPlayer('setMedia', urlParam).jPlayer('play');
  };
  // 暂停
  my.pause = function (t) {
    if (curUrl) {
      if (t === 0) {
        stopEvent = null;
        playEvent = null;
        playingEvent = null;
        playErrorEvent = null;
      }
      $jplayer.jPlayer('pause');
      if (stopEvent) {
        stopEvent();
      }
      if (callback) {
        callback();
      }
    }
  };
  // 停止
  my.stop = function () {
    if (this.getStatus() === '1' && curUrl) {
      $jplayer.jPlayer('stop');
    }
  };
  // 初始化
  my.init = function (baseUrl) {
    $jplayer = $('#jplayer');
    $jplayer.jPlayer({
      ready: function ready() {
        $jplayer.attr('status', '1');
      },
      // 监听播放事件 不是监听canplay事件
      play: function play(event) {
        if (!event.jPlayer.status.paused) {
          canplayStatus = true;
          if (event.jPlayer.status.duration === 0) {
            if (playEvent) {
              playEvent();
            }
          } else {
            if (playingEvent) {
              playingEvent();
            }
          }
        }
      },
      canplay: function canplay(event) {
        if (playingEvent && canplayStatus) {
          playingEvent();
        }
      },
      // 当播放结束时调用
      ended: function ended() {
        if (stopEvent) {
          canplayStatus = false;
          stopEvent();
        }
        if (callback) {
          curUrl = '';
          callback();
          callback = undefined;
        }
      },
      // 播放异常时调用
      error: function error(event) {
        // 如果浏览器选择使用flash播放，首次初始化播放器时监测flash是否满足使用
        // 如果不满足，百度统计一次，并请求一个空的swf文件触发浏览器下载flash插件
        if (!isReqSwf && event.jPlayer.version.flash === 'unknown') {
          $('#flashZone').html(genPlayerHtml('/flash/Jplayer.swf'));
          isReqSwf = true;
        }
        if (playErrorEvent) {
          playErrorEvent(event);
        }
      },
      // 播放器地址
      swfPath: '/hera/swf/Jplayer.swf',
      solution: 'html,flash',
      supplied: 'wav, mp3'
    });
  };
  function genPlayerHtml(flashUrl) {
    var htmlStr = '';
    htmlStr += '<object id="AudioFlashPlayer" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=8,0,0,0" width="0" height="0">';
    htmlStr += '<param name="movie" value="' + flashUrl + '" /> <param name="quality" value="high" /><param name="wmode" value="transparent" /> <param name="FlashVars" value="Caller= " /><param name="allowscriptaccess" value="sameDomain" /><param name="swfversion" value="10.0.22.0" />';
    htmlStr += '<embed src="' + flashUrl + '" id="AudioFlashPlayerFF"  width="0" height="0" quality="high"  pluginspage="http://www.adobe.com/shockwave/download/download.cgi?P1_Prod_Version=ShockwaveFlash" wmode="transparent" swfversion="10.0.22.0"  flashvars=""  type="application/x-shockwave-flash" allowscriptaccess="sameDomain" > ';
    htmlStr += '</embed></object>';
    return htmlStr;
  }

  return my;
}({});
player.init();


/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(5);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(6);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */





function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension() {
  var $suspension = $(".affix");
  var $backTop = $(".affix-bottom");
  var $panelSuggest = $(".affix-panel-content__suggest");
  var $panelApplet = $(".affix-panel-content__applet");
  var $panelAdvice = $(".affix-panel-content__advice");
  var $iframe = $(".affix-panel-content__iframe");
  var timer = null;
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 204) {
      $suspension.removeClass("affix_fixed");
    } else {
      $suspension.addClass("affix_fixed");
    }
    if (scrollTop > 204) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $backTop.click(function () {
    $("body, html").animate({ scrollTop: 0 }, 500);
    return false;
  });

  $(".affix-advice").click(function () {
    clearTimeout(timer);
    user["e" /* getUserinfo */]().then(function (res) {
      if (res.code === 80000) {
        var jumpBack = typeof window !== "undefined" ? Base64.encode(window.location.href) : "";
        window.location.href = prod["a" /* config */].PASSPORT_NEW + "/login?jump=" + jumpBack;
      } else {
        $panelAdvice.removeClass("show");
        $panelAdvice.addClass("show");
        $iframe[0].contentWindow.postMessage({ type: 'showBotChat' }, '*');
      }
    });
  });
  $(".affix-suggest").mouseenter(function () {
    clearTimeout(timer);
    $panelApplet.removeClass("show");
    $panelSuggest.addClass("show");
  });
  $(".affix-suggest").mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $panelSuggest.mouseenter(function () {
    clearTimeout(timer);
    $panelSuggest.addClass("show");
  });
  $panelSuggest.mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $(".affix-applet").mouseenter(function () {
    $panelSuggest.removeClass("show");
    $panelApplet.addClass("show");
  });
  $(".affix-applet").mouseleave(function () {
    $panelApplet.removeClass("show");
  });

  function checkImLog() {
    user["e" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["e" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + "/login?jump=" + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  // checkImLog();
}

var methods = {
  setIframe: function setIframe(w, h) {
    $(".affix-panel-content__iframe").width(w).height(h);
  }
};
$(function () {
  window.addEventListener("message", function (e) {
    if (e.data.type === 'dom') {
      var data = e.data.data;

      var width = data.width;
      var height = data.height + 12;
      methods.setIframe(width, height);
    }
    if (e.data.type === 'close') {
      $(".affix-panel-content__advice").removeClass('show');
    }
  });
});


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_solutions_soundLibrary_scss__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_solutions_soundLibrary_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scss_solutions_soundLibrary_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_solutions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_libs_jplayer_init_audio__ = __webpack_require__(35);





var soundLibrary = function (_self) {
  _self.data = [[
  // {
  //   imgUrl: '/hera/img/speaker-photo/small/xiaoyan.png',
  //   name: '虫虫',
  //   characteristic: '青年女声',
  //   voice: '甜美亲切',
  //   env: '录音棚',
  //   type: '品质库',
  //   playUrl: '//cdn.aidaxue.com/soundLibrary/chongchong'
  // },
  {
    imgUrl: '/hera/img/speaker-photo/small/yefang.png',
    name: '当当',
    characteristic: '青年女声',
    voice: '轻快自然',
    env: '录音棚',
    type: '品质库',
    playUrl: '//cdn.aidaxue.com/soundLibrary/dangdang'
  }, {
    imgUrl: '/hera/img/speaker-photo/small/xiaoyu.png',
    name: '宁宁',
    characteristic: '男童声',
    voice: '稚嫩童声',
    env: '录音棚',
    type: '品质库',
    playUrl: '//cdn.aidaxue.com/soundLibrary/ningning'
  }], [{
    imgUrl: '/hera/img/speaker-photo/small/hongshu.png',
    name: '超哥',
    characteristic: '青年男声',
    voice: '大气稳重',
    env: '录音棚',
    type: '品质库',
    playUrl: '//cdn.aidaxue.com/soundLibrary/chaoge'
  }, {
    imgUrl: '/hera/img/speaker-photo/small/lizhengchun.png',
    name: '刚哥',
    characteristic: '中年男声',
    voice: '深沉浑厚',
    env: '录音棚',
    type: '品质库',
    playUrl: '//cdn.aidaxue.com/soundLibrary/gangge'
  }, {
    imgUrl: '/hera/img/speaker-photo/small/hongshu.png',
    name: '七哥',
    characteristic: '青年男声',
    voice: '磁性浑厚',
    env: '录音棚',
    type: '品质库',
    playUrl: '//cdn.aidaxue.com/soundLibrary/qige'
  }], [{
    imgUrl: '/hera/img/speaker-photo/small/nannan.png',
    name: '百合仙子',
    characteristic: '青年女声',
    voice: '淡定',
    env: '录音棚',
    type: '品质库',
    playUrl: '//cdn.aidaxue.com/soundLibrary/baihexianzi'
  }, {
    imgUrl: '/hera/img/speaker-photo/small/lizhengchun.png',
    name: '大灰狼',
    characteristic: '中年男声',
    voice: '低沉',
    env: '录音棚',
    type: '品质库',
    playUrl: '//cdn.aidaxue.com/soundLibrary/dahuilang'
  }, {
    imgUrl: '/hera/img/speaker-photo/small/lizhengchun.png',
    name: '原野',
    characteristic: '中年男声',
    voice: '激情',
    env: '录音棚',
    type: '品质库',
    playUrl: '//cdn.aidaxue.com/soundLibrary/yuanye'
  }]];
  _self.setList = function (i) {
    var _html = '';
    var _list = _self.data[i];
    _list.forEach(function (element) {
      _html += '\n        <ul>\n          <li>\n            <i><img src="' + element.imgUrl + '"></i>\n            <span>' + element.name + '</span>\n          </li>\n          <li>' + element.characteristic + '</li>\n          <li>' + element.voice + '</li>\n          <li>' + element.env + '</li>\n          <li>' + element.type + '</li>\n          <li>\n            <i class="voice-play" title="\u8BD5\u542C" data-play-url="' + element.playUrl + '"></i>\n          </li>\n        </ul>\n      ';
    });
    $('.solutions-item-apply .voice-table-content').html('').append(_html);
  };
  _self.playAudio = function (url) {
    __WEBPACK_IMPORTED_MODULE_3_js_libs_jplayer_init_audio__["a" /* player */].buttonClick({
      wav: url + '.wav',
      mp3: url + '.mp3'
    }, null, function () {}, function () {
      $('.voice-play').removeClass('voice-pause');
    }, function () {
      $('.voice-play').removeClass('voice-pause');
    });
  };
  _self.stopAudio = function () {
    __WEBPACK_IMPORTED_MODULE_3_js_libs_jplayer_init_audio__["a" /* player */].stop();
  };
  return _self;
}(window.soundLibrary || {});

$(function () {
  soundLibrary.setList(0);
  var bindEvent = function bindEvent() {
    $('.voice-play').bind('click', function () {
      if ($(this).hasClass('voice-pause')) {
        $('.voice-play').removeClass('voice-pause');
        soundLibrary.stopAudio();
      } else {
        $('.voice-play').removeClass('voice-pause');
        $(this).addClass('voice-pause');
        soundLibrary.playAudio($(this).data('playUrl'));
      }
    });
  };
  bindEvent();
  $('.voice-scene-wrap .voice-scene').on('click', function () {
    soundLibrary.stopAudio();
    $('.voice-scene').removeClass('active');
    $(this).addClass('active');
    soundLibrary.setList($(this).data('index'));
    bindEvent();
  });
});

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export floatMenu */
/**
 * Created by lycheng on 2017/12/4.
 * 右边导航
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    difference: 5, // 为了避免top与tops临界点差值过小时，animate不触发的问题
    $container: $('html,body'),
    checkedClass: 'nav-checked'
  },
  init: function init() {
    floatMenu.bindEvent();
    floatMenu.methods.rePosition();
  },
  bindEvent: function bindEvent() {
    $('.js-custom-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target');
      floatMenu.methods.toPosition(target);
    });
    window.onscroll = function () {
      floatMenu.methods.rePosition();
    };
  },
  methods: {
    toPosition: function toPosition(target) {
      var top = $('.' + target).offset().top - floatMenu.config.top + floatMenu.config.difference;
      floatMenu.config.$container.animate({ scrollTop: Math.floor(top) }, 500);
    },
    rePosition: function rePosition() {
      var tops = [];
      var top = $('body').scrollTop() || $('html').scrollTop();
      var $navCon = $('.js-custom-nav-fall');
      var $navItem = $('.js-custom-nav-fall li');
      var targets = [];
      var i = 0;
      $navItem.each(function () {
        targets.push($(this).attr('target'));
      });

      for (i = 0; i < targets.length; i++) {
        if ($('.' + targets[i]).offset()) {
          tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top);
        }
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height());

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass);
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass);
        }
      }
      var windowPosition = $(window).scrollTop();
      if (windowPosition >= 300) {
        $navCon.show();
      } else {
        $navCon.hide();
      }
    }

  }
};
floatMenu.init();


/***/ })

},[863]);


// WEBPACK FOOTER //
// js/solutions/soundLibrary.89903bc11ab49001bb5e.bundle.js